export default [
  {
    src: 'images/at_f/PaidLandingPage/BienZenker.png',
    width: '43',
    height: '40'
  },
  {
    src: 'images/at_f/PaidLandingPage/HeinzVonHeiden.png',
    width: '92',
    height: '28'
  },
  {
    src: 'images/at_f/PaidLandingPage/SchwoererHaus.png',
    width: '80',
    height: '22'
  },
  {
    src: 'images/at_f/PaidLandingPage/TownAndCountry.png',
    width: '52',
    height: '40'
  },
  {
    src: 'images/at_f/PaidLandingPage/Danwood.png',
    width: '97',
    height: '28'
  },
  {
    src: 'images/at_f/PaidLandingPage/Viebrockhaus.png',
    width: '84',
    height: '26'
  },
  {
    src: 'images/at_f/PaidLandingPage/Ytong.png',
    width: '40',
    height: '40'
  },
  {
    src: 'images/at_f/PaidLandingPage/Helma.png',
    width: '42',
    height: '38'
  },
  {
    src: 'images/at_f/PaidLandingPage/LivingHaus.png',
    width: '42',
    height: '44'
  },
  {
    src: 'images/at_f/PaidLandingPage/Hansehaus.png',
    width: '46',
    height: '32'
  }
]
